import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Icon from '../icons/icon'
import btnImg from '../../styles/images/paypal.svg'

const IconButton = props => (
  <button
    className={classNames({
      'icon-button': true,
      saved: props.saved,
      upper: props.upperValue,
      disabled: props.disabled,
      [props.className]: props.className
    })}
    onClick={props.onClick}
    type={props.type}
  >
    {props.hasImage ? (
      <img className='button-img' src={btnImg} alt={props.alt} />
    ) : (
      <Icon name={props.iconName} />
    )}
    {props.text ? <span>{props.text}</span> : null}
  </button>
)

IconButton.propTypes = {
  text: PropTypes.string,
  iconName: PropTypes.string,
  saved: PropTypes.bool,
  upperValue: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  type: PropTypes.string,
  hasImage: PropTypes.bool,
  alt: PropTypes.string
}

export default IconButton



// WEBPACK FOOTER //
// ./src/ui/buttons/icon-button.js